import { formatTime } from '../types';
import ReactMarkdown from 'react-markdown';
import type { Message } from '../types';

interface MessageListProps {
  messages: Message[];
  isStreaming: boolean;
}

export function MessageList({ messages, isStreaming }: MessageListProps) {
  if (messages.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      {messages.map((msg, idx) => (
        <MessageBubble key={msg.id} message={msg} showTime={idx === 0 || messages[idx - 1]?.role !== msg.role} />
      ))}
      {isStreaming && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '0.5rem', color: 'var(--fg-muted)', fontSize: '0.75rem' }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.375rem' }}>
            <span className="spinner" style={{ width: '12px', height: '12px', border: '2px solid var(--border)', borderTopColor: 'var(--primary)', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
            Gerando resposta...
          </span>
        </div>
      )}
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}

function MessageBubble({ message, showTime }: { message: Message; showTime: boolean }) {
  const isUser = message.role === 'user';

  return (
    <div style={{
      display: 'flex',
      flexDirection: isUser ? 'row-reverse' : 'row',
      gap: '0.5rem',
      alignItems: 'flex-end',
    }}>
      {!isUser && (
        <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', flexShrink: 0 }}>
          🤖
        </div>
      )}
      <div style={{
        maxWidth: '80%',
        minWidth: 0,
        padding: '0.75rem 1rem',
        borderRadius: 'var(--radius)',
        background: isUser ? 'var(--primary)' : 'var(--bg-elevated)',
        border: isUser ? 'none' : '1px solid var(--border)',
        color: isUser ? 'white' : 'var(--fg)',
      }}>
        {isUser ? (
          <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', fontSize: '0.9375rem', lineHeight: 1.5 }}>{message.content}</div>
        ) : (
          <div className="message-markdown">
            <ReactMarkdown skipHtml>{message.content}</ReactMarkdown>
          </div>
        )}
        {showTime && (
          <div style={{ marginTop: '0.375rem', fontSize: '0.625rem', opacity: 0.6, textAlign: isUser ? 'right' : 'left' }}>
            {formatTime(message.createdAt)}
          </div>
        )}
      </div>
      {isUser && (
        <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem', flexShrink: 0 }}>
          👤
        </div>
      )}
    </div>
  );
}
